import { render, staticRenderFns } from "./AzurePermissionsView.vue?vue&type=template&id=c46b3bc0&scoped=true&"
import script from "./AzurePermissionsView.vue?vue&type=script&lang=ts&"
export * from "./AzurePermissionsView.vue?vue&type=script&lang=ts&"
import style0 from "./AzurePermissionsView.vue?vue&type=style&index=0&id=c46b3bc0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c46b3bc0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VContainer,VSimpleTable})
